export default __webpack_public_path__ + "static/media/Camion4.f141ca42.png";